import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

const { spacing, colors, typography } = THEME;

export const styles = StyleSheet.create({
	container: {
		padding: spacing.lg,
		maxWidth: 800,
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: spacing.lg,
	},
	title: {
		fontSize: typography.fontSizes.xl,
		fontWeight: 600,
		color: colors.text.main,
	},
	actions: {
		display: 'flex',
		gap: spacing.sm,
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.lg,
	},
	formGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	label: {
		fontSize: typography.fontSizes.sm,
		fontWeight: 600,
		color: colors.text.main,
	},
	textArea: {
		minHeight: 120,
	},
	technicalPromptArea: {
		minHeight: 200,
		resize: 'vertical',
	},
	objectivePromptArea: {
		minHeight: 150,
		resize: 'vertical',
	},
	selectorsContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	selectorRow: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
	},
	selectorInput: {
		flex: 1,
	},
	addSelectorButton: {
		alignSelf: 'flex-start',
	},
	errorMessage: {
		color: colors.danger.main,
		fontSize: typography.fontSizes.sm,
		marginTop: spacing.xs,
	},
	infoMessage: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		marginTop: spacing.xs,
		fontStyle: 'italic',
	},
	variablesContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	variableRow: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
	},
	variableKeyInput: {
		flex: 1,
		maxWidth: 200,
	},
	variableValueInput: {
		flex: 2,
	},
	emptyVariables: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		fontStyle: 'italic',
		padding: spacing.md,
		backgroundColor: colors.background.light,
		borderRadius: 4,
	},
	previewContainer: {
		marginTop: spacing.md,
		padding: spacing.md,
		backgroundColor: colors.background.light,
		borderRadius: 4,
		border: `1px solid ${colors.border.main}`,
	},
	previewHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: spacing.sm,
	},
	previewTitle: {
		fontSize: typography.fontSizes.sm,
		fontWeight: 600,
		color: colors.text.main,
	},
	previewContent: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
		whiteSpace: 'pre-wrap',
		fontFamily: 'monospace',
		maxHeight: 300,
		overflowY: 'auto',
	},
	highlightedVariable: {
		backgroundColor: colors.primary.light,
		padding: '2px 4px',
		borderRadius: 2,
	},
});
